import { CustomStyles, getStyles } from '@utils/styles'
import {
  DocumentComponentBlocks,
  DocumentRenderer,
  DocumentRendererData,
} from '../DocumentRenderer'
import defaultStyles, { StylesClassNames } from './style'

export type ArticleDocumentData = {
  documentRendererData: DocumentRendererData
}

type Props = ArticleDocumentData & {
  csx?: CustomStyles<StylesClassNames>
  extraComponentBlocks?: DocumentComponentBlocks
}

export function ArticleDocument({
  documentRendererData,
  csx,
  extraComponentBlocks,
}: Props) {
  const styles = getStyles(defaultStyles, csx)

  const headings: {
    level?: string
    text: string
    id: string
  }[] = []

  documentRendererData.document.forEach((node) => {
    if (node.type === 'heading') {
      headings.push({
        level: node.level,
        text: node.children[0].text,
        id: node.children[0].text.trim().replace(/\s+/g, '-').toLowerCase(),
      })
    }
  })

  return (
    <DocumentRenderer
      {...documentRendererData}
      extraComponentBlocks={{
        ...(documentRendererData.extraComponentBlocks ?? {}),
        ...(extraComponentBlocks ?? {}),
      }}
      {...styles('documentWrapper')}
    />
  )
}
